// extracted by mini-css-extract-plugin
export default {"container":"FullScreenSpinner_container__-Zpts"};